<audio #audioPlayer></audio>

<div class="container mt-5">

    <div class="row justify-content-center">
        <div>
            <div class="card shadow-lg">
                <div class="card-header bg-primary text-white text-center">
                    <h3 class="mt-2">{{ isEditMode ? 'Edit' : 'Create' }} Knowledge Base Item</h3>
                    <h6>{{serviceArea}}</h6>
                </div>
                <div class="card-body">
                    <form #kbForm="ngForm" (ngSubmit)="saveKbItem()">

                        <fieldset readOnlyIfNoGroupPermissionDirective>

                        <div class="row">
                            <div class="col mb-3">
                                <label class="form-label">Description</label>
                                <input type="text" class="form-control" placeholder="Enter a description" appAutoFocus #descriptionInput
                                    [(ngModel)]="kbItem.description" name="description" required>
                            </div>
                        </div>
                
                        <hr />

                        <div class="card shadow-lg mb-3">
                            <div class="card-header bg-secondary text-muted">
                                <h6 class="mt-2">Web</h6>
                            </div>
                            <div class="card-body">
                                <!-- Web Questions (Multi-Select)-->
                                <div class="row">
                                    <div class="mb-3 col">
                                        <label class="form-label">Web Questions</label>

                                        <p-multiselect [disabled]="!hasPermission" [options]="availableWebIntents" [ngModel]="webQuestions$ | async"
                                            virtualScroll="true" filter="true" optionValue="id"
                                            [loading]="isLoadingSecondary"
                                            optionLabel="description" placeholder="Select Alternate Questions"
                                            [maxSelectedLabels]="3" styleClass="w-100 md:w-80" showClear="true"
                                            display="chip" (onClear)="webQuestions$.next([])"
                                            (ngModelChange)="webQuestions$.next($event)" scrollHeight="400px"
                                            virtualScrollItemSize="75" name="webQuestions">

                                            <ng-template #dropdownicon>
                                                <i class="pi pi-list"></i>
                                            </ng-template>

                                            <ng-template #header>
                                                <div class="bg-primary text-white p-2 text-center">Select Web
                                                    Questions
                                                </div>
                                            </ng-template>

                                            <ng-template let-intent #item>
                                                <div class="d-flex flex-column">
                                                    <strong>{{ intent.description }}</strong>
                                                    <div class="text-muted small">{{ intent.qualifiedName }}</div>
                                                    <div class="small fst-italic text-secondary">Q: {{
                                                        intent.sampleQuestion }}
                                                    </div>
                                                    <div class="small text-success">A: {{ intent.sampleAnswer }}</div>
                                                </div>
                                            </ng-template>
                                        </p-multiselect>

                                            <!-- Error Message for Web Questions -->
                                            <div *ngIf="webQuestions$.value.length > 0 && !kbItem.webAnswer.trim()" class="text-danger small mt-1">
                                                Please provide a Web Answer for the selected Web Questions.
                                            </div>                                        
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- Answers -->
                                    <div class="mb-3">
                                        <label class="form-label">Web Answer</label>
                                        <i class="bi bi-info-circle text-muted ms-1 fs-6" data-bs-toggle="tooltip"
                                            title="Web Answer"></i>
                                        <app-markdown-editor [disabled]="!hasPermission" [(ngModel)]="kbItem.webAnswer"
                                            name="webAnswer"></app-markdown-editor>
                                        <!-- <pre>Markdown Output: {{ item.webAnswer }}</pre> -->
                                    </div>
                                </div>

                                <!-- Refinement Questions -->
                                <div class="row">
                                    <div class="col-12">

                                        <div class="card mb-3 border shadow-sm">
                                            <div class="card-header fw-bold">Refinement Questions</div>

                                            <div class="card-body">
                                                <div *ngFor="let refinement of kbItem.webRefinementQuestions; let i = index"
                                                    class="row align-items-center gx-3 gy-2">

                                                    <div class="col">
                                                        <label class="form-label small text-muted">Target Knowledge Base
                                                            Item</label>

                                                        <div>
                                                            <p-select [disabled]="!hasPermission" *ngIf="refinement.targetKnowledgeBaseItem"
                                                                [(ngModel)]="refinement.targetKnowledgeBaseItem.id"
                                                                [options]="kbItems" optionLabel="description"
                                                                optionValue="id" styleClass="w-100 md:w-56"
                                                                filter="true" virtualScroll="true"
                                                                virtualScrollItemSize="38" showClear="true"
                                                                placeholder="Select Knowledge Base Item" required="true"
                                                                name="p-select-refinementItem{{i}}_web">

                                                                <ng-template #header>
                                                                    <div class="bg-primary text-white p-2 text-center">
                                                                        Select
                                                                        Knowledge Base Item</div>
                                                                </ng-template>

                                                                <ng-template let-kbItem #item>
                                                                    <div class="d-flex align-items-center gap-2">
                                                                        <i class="pi pi-lightbulb text-warning"></i>
                                                                        <div>
                                                                            <strong>{{ kbItem.description }}</strong>
                                                                            <div class="small text-success">
                                                                                {{kbItem.answer }}</div>
                                                                        </div>
                                                                    </div>
                                                                </ng-template>
                                                            </p-select>
                                                        </div>
                                                    </div>

                                                    <div class="col">
                                                        <label class="form-label small text-muted">Display Text</label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="refinement.displayText"
                                                            name="refinementWebDisplayText{{i}}"
                                                            placeholder="Enter Display Text" required>
                                                    </div>

                                                    <!-- Delete Button -->
                                                    <div
                                                        class="col-md-1 d-flex align-items-center justify-content-center">
                                                        <label class="form-group"></label>
                                                        <div class="btn d-block">&nbsp;
                                                            <button type="button" class="btn btn-danger btn-sm d-block"
                                                                (click)="confirmDeleteRefinementQuestion(i, deleteConfirmModal, 'web')">
                                                                <i class="bi bi-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <hr>
                                                <div>
                                                    <!-- Add Refinement Question Button -->
                                                    <button type="button" class="btn btn-secondary"
                                                        (click)="addRefinementQuestion(kbItem.webRefinementQuestions)">
                                                        <i class="bi bi-plus-lg"></i> Add Refinement Question
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card shadow-lg mb-3">
                            <div class="card-header bg-secondary text-muted">
                                <h6 class="mt-2">Voice/SMS</h6>
                            </div>
                            <div class="card-body">

                                <!-- Voice/SMS Questions (Multi-Select)-->
                                <div class="row">
                                    <div class="mb-3 col">
                                        <label class="form-label">Voice/SMS Questions</label>

                                        <p-multiselect [disabled]="!hasPermission" [options]="availableVoiceSMSIntents" showClear="true"
                                            (onClear)="voiceSMSQuestions$.next([])"
                                            [ngModel]="voiceSMSQuestions$ | async"
                                            [loading]="isLoadingSecondary"
                                            (ngModelChange)="voiceSMSQuestions$.next($event)" scrollHeight="400px"
                                            filter="true" virtualScroll="true" virtualScroll="true"
                                            virtualScrollItemSize="75" optionValue="id" optionLabel="description"
                                            name="voiceSMSQuestions" display="chip"
                                            placeholder="Select Alternate Questions" [maxSelectedLabels]="3"
                                            styleClass="w-100 md:w-56">

                                            <ng-template #dropdownicon>
                                                <i class="pi pi-list"></i>
                                            </ng-template>

                                            <ng-template #header>
                                                <div class="bg-primary text-white p-2 text-center">Select Questions
                                                </div>
                                            </ng-template>

                                            <ng-template let-intent #item>
                                                <div class="d-flex flex-column">
                                                    <strong>{{ intent.description }}</strong>
                                                    <div class="text-muted small">{{ intent.qualifiedName }}</div>
                                                    <div class="small fst-italic text-secondary">Q: {{
                                                        intent.sampleQuestion }}
                                                    </div>
                                                    <div class="small text-success">A: {{ intent.sampleAnswer }}</div>
                                                </div>
                                            </ng-template>
                                        </p-multiselect>
                                         
                                            <!-- Error Message for Voice/SMS Questions -->
                                            <div *ngIf="voiceSMSQuestions$.value.length > 0 && !kbItem.voiceAnswer.trim() && !kbItem.smsAnswer.trim()" class="text-danger small mt-1">
                                                Please provide at least one Voice or SMS Answer for the selected Voice/SMS Questions.
                                            </div>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <div class="form-check form-switch">
                                      <input class="form-check-input" role="switch" type="checkbox"
                                        [(ngModel)]="kbItem.autoEscalate" id="autoEscalate" name="autoEscalate">
                                      <label for="autoEscalate" class="form-check-label">Auto Escalate</label>
                                    </div>
                                  </div>

                                <!-- Answers Section -->
                                <div class="row">
                                    <div class="mb-3">
                                        <label class="form-label">Voice Answer</label>
                                        <textarea class="form-control" placeholder="Enter Voice Answer" rows="4"
                                            [(ngModel)]="kbItem.voiceAnswer" name="voiceAnswer" [disabled]="kbItem.autoEscalate || kbItem.voiceSmsRefinementQuestions.length > 0"></textarea>
                                        <button type="button" class="btn btn-primary mt-2" [disabled]="kbItem.autoEscalate"
                                            (click)="playOutOfHoursMessage(kbItem.voiceAnswer)">
                                            Play Voice Answer
                                        </button>
                                    </div>
                          

                                    <div class="mb-3">
                                        <label class="form-label">SMS Answer</label>
                                        <textarea class="form-control" placeholder="Enter SMS Answer" rows="4" [disabled]="kbItem.autoEscalate || kbItem.voiceSmsRefinementQuestions.length > 0"
                                            [(ngModel)]="kbItem.smsAnswer" name="smsAnswer"></textarea>
                                    </div>
                                </div>

                                <!-- Refinement Questions -->
                                <div class="row">
                                    <div class="col-12">

                                        <div class="card mb-3 border shadow-sm">
                                            <div class="card-header fw-bold">Refinement Questions</div>

                                            <div class="card-body">
                                                <div *ngFor="let refinement of kbItem.voiceSmsRefinementQuestions; let i = index"
                                                    class="row align-items-center gx-3 gy-2">

                                                    <div class="col">
                                                        <label class="form-label small text-muted">Target Knowledge Base
                                                            Item</label>

                                                        <div>
                                                            <p-select [disabled]="!hasPermission" *ngIf="refinement.targetKnowledgeBaseItem"
                                                                [(ngModel)]="refinement.targetKnowledgeBaseItem.id"
                                                                [options]="kbItems" optionLabel="description"
                                                                optionValue="id" styleClass="w-100 md:w-56"
                                                                filter="true" virtualScroll="true"
                                                                virtualScrollItemSize="38" showClear="true"
                                                                placeholder="Select Knowledge Base Item" required="true"
                                                                name="p-select-refinementItem{{i}}_voice">

                                                                <ng-template #header>
                                                                    <div class="bg-primary text-white p-2 text-center">
                                                                        Select
                                                                        Knowledge Base Item</div>
                                                                </ng-template>

                                                                <ng-template let-kbItem #item>
                                                                    <div class="d-flex align-items-center gap-2">
                                                                        <i class="pi pi-lightbulb text-warning"></i>
                                                                        <div>
                                                                            <strong>{{ kbItem.description }}</strong>
                                                                            <div class="small text-success">
                                                                                {{kbItem.answer }}</div>
                                                                        </div>
                                                                    </div>
                                                                </ng-template>
                                                            </p-select>
                                                        </div>
                                                    </div>

                                                    <div class="col">
                                                        <label class="form-label small text-muted">Display Text</label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="refinement.displayText"
                                                            name="refinementVoiceDisplayText{{i}}"
                                                            placeholder="Enter Display Text" required>
                                                    </div>

                                                    <!-- Delete Button -->
                                                    <div
                                                        class="col-md-1 d-flex align-items-center justify-content-center">
                                                        <label class="form-group"></label>
                                                        <div class="btn d-block">&nbsp;
                                                            <button type="button" class="btn btn-danger btn-sm d-block"
                                                                (click)="confirmDeleteRefinementQuestion(i, deleteConfirmModal, 'phone' )">
                                                                <i class="bi bi-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <hr>
                                                <div>
                                                    <!-- Add Refinement Question Button -->
                                                    <button type="button" class="btn btn-secondary"
                                                        (click)="addRefinementQuestion(kbItem.voiceSmsRefinementQuestions)">
                                                        <i class="bi bi-plus-lg"></i> Add Refinement Question
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <!-- Escalation Department -->
                                    <div class="mb-4 col">
                                        <label class="form-label">Escalation Department</label>
                                        <select class="form-select" [(ngModel)]="kbItem.escalationDepartmentId"
                                            name="escalationDepartmentId">
                                            <option [ngValue]="null">None</option>
                                            <option *ngFor="let dept of departments" [value]="dept.id">{{ dept.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        </fieldset>

                        <!-- Action Buttons -->
                        <div class="d-flex justify-content-center mt-4">
                            <button type="submit" class="btn btn-primary me-2" [disabled]="kbForm.invalid || isLoadingSecondary || !areQuestionsAndAnswersValid()" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false" [componentDisabled]="kbForm.invalid || isLoadingSecondary">
                                {{ isEditMode ? 'Save Changes' : 'Create Item' }}
                            </button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Confirmation Modal for Refinement Question Deletion -->
<ng-template #deleteConfirmModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title text-danger"><i class="bi bi-exclamation-triangle"></i> Confirm Deletion</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to delete this Refinement Question?</p>
        <p class="text-muted small">This action cannot be undone.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="deleteRefinementQuestion(modal)">Delete</button>
    </div>
</ng-template>